import React from 'react'
import { withState, compose, shouldUpdate } from 'recompose'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'
import { Helmet } from 'react-helmet'

import LotsList from './LotList/index'
import Categories from './Categories'

const categoryClick = handler => (name, e) => {
  e && e.preventDefault()
  handler(name)
}

const Persons = ({ categories = [], setCategory, category, meta}) => (
  <div className='Persons'>
    <div className='Container'>
    <h1 className='Persons__header bottom-space'>
        <FormattedMessage id='art.expert_text' />
      </h1>
      <Helmet>
        <title>{meta.name}</title>
        <meta name='description' content={meta.description} />
        <meta property='og:title' content={meta.name} />
        <meta property='og:image' content={meta.image} />
        <meta property='og:url' content={window.location.href} />
        <meta property='og:description' content={meta.description} />
      </Helmet>
      {/*<Categories type='lots' onClick={categoryClick(setCategory)} typelot={'lots'} project={'600aaa9c80d1eb09402879e3'} current={category || null} classPrefix='Persons' withAll />*/}
      <LotsList params={{ category }} limit={50} type={'newPublished'} typelot={'lots'} containerClass='Persons__list' project={'600aaa9c80d1eb09402879e3'} listName={'Art'} expandable />
    </div>
  </div>
)

export default compose(
  withState('category', 'setCategory', null),
  shouldUpdate((props, np) => (np.category !== props.category)),
)(Persons)



// WEBPACK FOOTER //
// ./src/containers/Arts.jsx